/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-factory.js to modify the generation of this file.
import BlogNews from '../components/blogNews';
import BreadcrumbBar from '../components/breadcrumbBar';
import BuildAndPriceExternalLink from '../components/buildAndPriceExternalLink';
import CardCarousel from '../components/cardCarousel';
import CardColumnLayout from '../components/cardColumnLayout';
import CustomHtml from '../components/customHtml';
import DealerLocatorBreadcrumbBar from '../components/dealerLocatorBreadcrumbBar';
import DealerLocatorDetail from '../components/dealerLocatorDetail';
import DealerLocatorLanding from '../components/dealerLocatorLanding';
import DownloadBrochures from '../components/downloadBrochures';
import ExploreOurServices from '../components/exploreOurServices';
import ExternalComponent from '../components/externalComponent';
import FindDealer from '../components/findDealer';
import Footer from '../components/footer';
import FormPageNavigation from '../components/formPageNavigation';
import FullScreenMediaGallery from '../components/fullScreenMediaGallery';
import GenericPopUp from '../components/genericPopUp';
import Header from '../components/header';
import HeroBanner from '../components/heroBanner';
import InteractiveImage from '../components/interactiveImage';
import KeepInTouch from '../components/keepInTouch';
import LatestNews from '../components/latestNews';
import MediaGallery from '../components/mediaGallery';
import MosaicMediaGallery from '../components/mosaicMediaGallery';
import NavigationBar from '../components/navigationBar';
import NavigationBarAnchorComponent from '../components/navigationBarAnchorComponent';
import News from '../components/news';
import NewsDetail from '../components/newsDetail';
import NewsListing from '../components/newsListing';
import NextSteps from '../components/nextSteps';
import ProductAttachmentSeriesWithFilter from '../components/productAttachmentSeriesWithFilter';
import ProductBreadcrumbBar from '../components/productBreadcrumbBar';
import ProductBuildAndPriceLink from '../components/productBuildAndPriceLink';
import ProductCompatibleEquipmentListing from '../components/productCompatibleEquipmentListing';
import ProductCompatibleLoaderListing from '../components/productCompatibleLoaderListing';
import ProductDashboardEquipment from '../components/productDashboardEquipment';
import ProductDownloadBrochureListing from '../components/productDownloadBrochureListing';
import ProductFloatingMenu from '../components/productFloatingMenu';
import ProductHeroBanner from '../components/productHeroBanner';
import ProductHeroBannerSeriesDetail from '../components/productHeroBannerSeriesDetail';
import ProductLatestDownloadBrochures from '../components/productLatestDownloadBrochures';
import ProductLinesListing from '../components/productLinesListing';
import ProductLineSpecialOffers from '../components/productLineSpecialOffers';
import ProductModelCompatibleAttachmentListing from '../components/productModelCompatibleAttachmentListing';
import ProductModelCompatibleEquipmentListing from '../components/productModelCompatibleEquipmentListing';
import ProductModelDetailDownloadBrochures from '../components/productModelDetailDownloadBrochures';
import ProductModelDetailFeature from '../components/productModelDetailFeature';
import ProductModelDetailFullScreenMediaGallery from '../components/productModelDetailFullScreenMediaGallery';
import ProductModelDetailHeroSection from '../components/productModelDetailHeroSection';
import ProductModelDetailMediaGallery from '../components/productModelDetailMediaGallery';
import ProductModelDetailMosaicMediaGallery from '../components/productModelDetailMosaicMediaGallery';
import ProductModelDetailSolution from '../components/ProductModelDetailSolution';
import ProductModelDetailSpecCheck from '../components/productModelDetailSpecCheck';
import ProductModelDetailsSpecificationTable from '../components/productModelDetailsSpecificationTable';
import ProductModelsListing from '../components/productModelsListing';
import ProductModelSpecifications from '../components/productModelSpecifications';
import ProductPriorModelsWithFilter from '../components/productPriorModelsWithFilter';
import ProductSeoTags from '../components/productSeoTags';
import ProductSeriesCompatibleAttachmentListing from '../components/productSeriesCompatibleAttachmentListing';
import ProductSeriesCompatibleEquipmentListing from '../components/productSeriesCompatibleEquipmentListing';
import ProductSeriesDetailDownloadBrochures from '../components/productSeriesDetailDownloadBrochures';
import ProductSeriesDetailFeature from '../components/productSeriesDetailFeature';
import ProductSeriesDetailHeroSection from '../components/productSeriesDetailHeroSection';
import ProductSeriesDetailMosaicMediaGallery from '../components/productSeriesDetailMosaicMediaGallery';
import ProductSeriesDetailOverviewSolution from '../components/productSeriesDetailOverviewSolution';
import ProductSeriesDetailSpecCheck from '../components/productSeriesDetailSpecCheck';
import ProductSeriesDetailSpecialOffers from '../components/productSeriesDetailSpecialOffers';
import ProductSeriesDetailTestimonial from '../components/productSeriesDetailTestimonial';
import ProductSeriesFullScreenMediaGallery from '../components/productSeriesFullScreenMediaGallery';
import ProductSeriesListing from '../components/productSeriesListing';
import ProductSeriesListingDownloadBrochures from '../components/productSeriesListingDownloadBrochures';
import ProductSeriesListingUserExperience from '../components/productSeriesListingUserExperience';
import ProductSeriesMediaGallery from '../components/productSeriesMediaGallery';
import ProductSeriesNavigationBar from '../components/productSeriesNavigationBar';
import ProductSeriesView360 from '../components/productSeriesView360';
import ProductSpecialOfferDetail from '../components/productSpecialOfferDetail';
import ProductSpecialOffers from '../components/productSpecialOffers';
import ProductSpecialOffersDetailDownloadBrochures from '../components/ProductSpecialOffersDetailDownloadBrochures';
import ProductSpecialOffersDetailHeroBanner from '../components/ProductSpecialOffersDetailHeroBanner';
import ProductSpecialOffersListing from '../components/productSpecialOffersListing';
import QuickLinks from '../components/quickLinks';
import RemoteBuildAndPrice from '../components/remoteBuildAndPrice';
import SearchResults from '../components/searchResults';
import SitecoreJssForm from '../components/sitecoreJssForm';
import SmallHero from '../components/smallHero';
import SocialMedia from '../components/socialMedia';
import SpecCheck from '../components/specCheck';
import SplashComponent from '../components/splashComponent';
import SplitModule from '../components/splitModule';
import Table from '../components/table';
import TextModule from '../components/textModule';

const components = new Map();
components.set('BlogNews', BlogNews);
components.set('BreadcrumbBar', BreadcrumbBar);
components.set('BuildAndPriceExternalLink', BuildAndPriceExternalLink);
components.set('CardCarousel', CardCarousel);
components.set('CardColumnLayout', CardColumnLayout);
components.set('CustomHtml', CustomHtml);
components.set('DealerLocatorBreadcrumbBar', DealerLocatorBreadcrumbBar);
components.set('DealerLocatorDetail', DealerLocatorDetail);
components.set('DealerLocatorLanding', DealerLocatorLanding);
components.set('DownloadBrochures', DownloadBrochures);
components.set('ExploreOurServices', ExploreOurServices);
components.set('ExternalComponent', ExternalComponent);
components.set('FindDealer', FindDealer);
components.set('Footer', Footer);
components.set('FormPageNavigation', FormPageNavigation);
components.set('FullScreenMediaGallery', FullScreenMediaGallery);
components.set('GenericPopUp', GenericPopUp);
components.set('Header', Header);
components.set('HeroBanner', HeroBanner);
components.set('InteractiveImage', InteractiveImage);
components.set('KeepInTouch', KeepInTouch);
components.set('LatestNews', LatestNews);
components.set('MediaGallery', MediaGallery);
components.set('MosaicMediaGallery', MosaicMediaGallery);
components.set('NavigationBar', NavigationBar);
components.set('NavigationBarAnchorComponent', NavigationBarAnchorComponent);
components.set('News', News);
components.set('NewsDetail', NewsDetail);
components.set('NewsListing', NewsListing);
components.set('NextSteps', NextSteps);
components.set('ProductAttachmentSeriesWithFilter', ProductAttachmentSeriesWithFilter);
components.set('ProductBreadcrumbBar', ProductBreadcrumbBar);
components.set('ProductBuildAndPriceLink', ProductBuildAndPriceLink);
components.set('ProductCompatibleEquipmentListing', ProductCompatibleEquipmentListing);
components.set('ProductCompatibleLoaderListing', ProductCompatibleLoaderListing);
components.set('ProductDashboardEquipment', ProductDashboardEquipment);
components.set('ProductDownloadBrochureListing', ProductDownloadBrochureListing);
components.set('ProductFloatingMenu', ProductFloatingMenu);
components.set('ProductHeroBanner', ProductHeroBanner);
components.set('ProductHeroBannerSeriesDetail', ProductHeroBannerSeriesDetail);
components.set('ProductLatestDownloadBrochures', ProductLatestDownloadBrochures);
components.set('ProductLinesListing', ProductLinesListing);
components.set('ProductLineSpecialOffers', ProductLineSpecialOffers);
components.set('ProductModelCompatibleAttachmentListing', ProductModelCompatibleAttachmentListing);
components.set('ProductModelCompatibleEquipmentListing', ProductModelCompatibleEquipmentListing);
components.set('ProductModelDetailDownloadBrochures', ProductModelDetailDownloadBrochures);
components.set('ProductModelDetailFeature', ProductModelDetailFeature);
components.set('ProductModelDetailFullScreenMediaGallery', ProductModelDetailFullScreenMediaGallery);
components.set('ProductModelDetailHeroSection', ProductModelDetailHeroSection);
components.set('ProductModelDetailMediaGallery', ProductModelDetailMediaGallery);
components.set('ProductModelDetailMosaicMediaGallery', ProductModelDetailMosaicMediaGallery);
components.set('ProductModelDetailSolution', ProductModelDetailSolution);
components.set('ProductModelDetailSpecCheck', ProductModelDetailSpecCheck);
components.set('ProductModelDetailsSpecificationTable', ProductModelDetailsSpecificationTable);
components.set('ProductModelsListing', ProductModelsListing);
components.set('ProductModelSpecifications', ProductModelSpecifications);
components.set('ProductPriorModelsWithFilter', ProductPriorModelsWithFilter);
components.set('ProductSeoTags', ProductSeoTags);
components.set('ProductSeriesCompatibleAttachmentListing', ProductSeriesCompatibleAttachmentListing);
components.set('ProductSeriesCompatibleEquipmentListing', ProductSeriesCompatibleEquipmentListing);
components.set('ProductSeriesDetailDownloadBrochures', ProductSeriesDetailDownloadBrochures);
components.set('ProductSeriesDetailFeature', ProductSeriesDetailFeature);
components.set('ProductSeriesDetailHeroSection', ProductSeriesDetailHeroSection);
components.set('ProductSeriesDetailMosaicMediaGallery', ProductSeriesDetailMosaicMediaGallery);
components.set('ProductSeriesDetailOverviewSolution', ProductSeriesDetailOverviewSolution);
components.set('ProductSeriesDetailSpecCheck', ProductSeriesDetailSpecCheck);
components.set('ProductSeriesDetailSpecialOffers', ProductSeriesDetailSpecialOffers);
components.set('ProductSeriesDetailTestimonial', ProductSeriesDetailTestimonial);
components.set('ProductSeriesFullScreenMediaGallery', ProductSeriesFullScreenMediaGallery);
components.set('ProductSeriesListing', ProductSeriesListing);
components.set('ProductSeriesListingDownloadBrochures', ProductSeriesListingDownloadBrochures);
components.set('ProductSeriesListingUserExperience', ProductSeriesListingUserExperience);
components.set('ProductSeriesMediaGallery', ProductSeriesMediaGallery);
components.set('ProductSeriesNavigationBar', ProductSeriesNavigationBar);
components.set('ProductSeriesView360', ProductSeriesView360);
components.set('ProductSpecialOfferDetail', ProductSpecialOfferDetail);
components.set('ProductSpecialOffers', ProductSpecialOffers);
components.set('ProductSpecialOffersDetailDownloadBrochures', ProductSpecialOffersDetailDownloadBrochures);
components.set('ProductSpecialOffersDetailHeroBanner', ProductSpecialOffersDetailHeroBanner);
components.set('ProductSpecialOffersListing', ProductSpecialOffersListing);
components.set('QuickLinks', QuickLinks);
components.set('RemoteBuildAndPrice', RemoteBuildAndPrice);
components.set('SearchResults', SearchResults);
components.set('SitecoreJssForm', SitecoreJssForm);
components.set('SmallHero', SmallHero);
components.set('SocialMedia', SocialMedia);
components.set('SpecCheck', SpecCheck);
components.set('SplashComponent', SplashComponent);
components.set('SplitModule', SplitModule);
components.set('Table', Table);
components.set('TextModule', TextModule);

export default function componentFactory(componentName) {
  return components.get(componentName);
};
